module.exports = __webpack_public_path__ + "static/media/FuturaPTBold.f3483f64.otf";